import { Box, styled } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

export const SummaryContainer = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.custom.grey9}`,
  borderBottom: `1px solid ${theme.palette.custom.grey9}`,
  padding: '16px 0',
}));

export const Row = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TotalTitle = styled(CustomTypography)(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '20px',
  fontWeight: 500,
  fontStyle: 'medium',
}));

export const FullPrice = styled(CustomTypography)(({ theme }) => ({
  color: theme.palette.custom.black[30],
  textDecoration: 'line-through',
  fontWeight: 300,
  fontSize: '16px',
}));
